import { useQuery } from '@tanstack/react-query'

import { errorToast } from 'common/components/toastNotification'
import { useAppSelector } from 'common/hooks/redux'

import { fetchGraphs } from '../api'
import { personalizationKeys } from '../queryKeys'

const useGetGraphsQuery = ({
  channelId,
  personalizationId,
}: {
  channelId?: string
  personalizationId: string
}) => {
  const accountId = useAppSelector((state) => state.authStates.accountId)

  const query = useQuery(
    personalizationKeys.graphs,
    () => fetchGraphs({ accountId, channelId, personalizationId }),
    {
      onError: () => {
        errorToast('Something went wrong. Please try again.')
      },
    }
  )

  return query
}

export default useGetGraphsQuery
